<template>
  <div class="footer">
    <van-row class="footer-container" style="margin-top: 5px;">
      <van-col span="6" class="footer__icon" @click="$util.router.goto('/index')">
        <img :src="getHomeImg" alt="" class="footer__image" />
      </van-col>
      <van-col span="6" class="footer__icon" @click="$util.router.goto('/pool')">
        <img :src="getChangeImg" alt="" class="footer__image" />
      </van-col>
      <van-col span="6" class="footer__icon" @click="$util.router.goto('/coop')">
        <img :src="getServiceImg" alt="" class="footer__image" />
      </van-col>
      <van-col span="6" class="footer__icon" @click="$util.router.goto('/user')">
        <img :src="getMyImg" alt="" class="footer__image" />
      </van-col>
    </van-row>
    <van-row class="footer-container footer__text">
      <van-col span="6" class="footer__text-item" 
        :class="this.$route.path=='/index' ? 'banner-selected' : ''" 
        @click="$util.router.goto('/index')">{{ $t("home page") }}</van-col>
      <van-col span="6" class="footer__text-item" 
        :class="this.$route.path=='/pool' ? 'banner-selected' : ''" 
        @click="$util.router.goto('/pool')">{{ $t("Ore pool") }}</van-col>
      <van-col span="6" class="footer__text-item" 
        :class="this.$route.path=='/coop' ? 'banner-selected' : ''" 
        @click="$util.router.goto('/coop')">{{ $t("cooperation") }}</van-col>
      <van-col span="6" class="footer__text-item" 
        :class="this.$route.path=='/user' ? 'banner-selected' : ''" 
        @click="$util.router.goto('/user')">{{ $t("my") }}</van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  name: 'DfUi2Banner',
  computed: {
    getHomeImg() {
      return this.$route.path == "/index" ? require("@/assets/ui2/images/nav_home.png") : require("@/assets/ui2/images/nav_home_n.png");
    },
    getChangeImg() {
      return this.$route.path == "/pool" ? require("@/assets/ui2/images/nav_pool.png") : require("@/assets/ui2/images/nav_pool_n.png");
    },
    getServiceImg() {
      return this.$route.path == "/coop" ? require("@/assets/ui2/images/nav_coop.png") : require("@/assets/ui2/images/nav_coop_n.png");
    },
    getMyImg() {
      return this.$route.path == "/user" ? require("@/assets/ui2/images/nav_me.png") : require("@/assets/ui2/images/nav_me_n.png");
    },
  }
}
</script>

<style scoped lang="scss">
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 50px;
  background-color: #212244;
  max-width: var(--max-screen-width) !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.footer-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer__icon {
  font-size: 24px;
  display: flex;
  justify-content: center;
}

.footer__image {
  width: 24px;
  height: 24px;
}

.footer__text {
  margin-top: 3px;
  color: #a9abfc;
}

.footer__text-item {
  font-size: 10px;
  display: flex;
  justify-content: center;
  color: #505a87
}
.banner-selected{
    color: $text-color-active;
}
</style>
